import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectStatus } from '../../customComponents/SelectStatus';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';
import { SelectAnswerType } from '../../customComponents/SelectAnswerType';
export { filterFields } from '../../customComponents/filterFields';


export const initObject = {
  id: undefined,
  title: "",
  code: 0,
  allowedAnswer: 0,
  answerType: 0,
  categoryId: null,
  categoryTitle: 0,
  isDeleted: false
};

export const columns = [
  {
    dataField: "title",
    text: "عنوان",
    sort: true,
    sortCaret: sortCaret,
  },

  {
    dataField: "code",
    text: "کد",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری پرسش",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "answerType",
    text: "نوع پاسخ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.AnswerTypeColumnFormatter,
  },
  {
    dataField: "isDeleted",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },

];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان",
        label: "عنوان",
        rowIdx: 1,
        class: "col-lg-6"
      },
      {
        name: "code",
        type: "text",
        component: Input,
        placeholder: "کد",
        label: "کد",
        rowIdx: 2,
        class: "col-lg-6"
      },
      {
        name: "answerType",
        type: "component",
        component: SelectAnswerType,
        placeholder: "نوع پاسخ",
        label: "نوع پاسخ",
        rowIdx: 5,
        class: "col-lg-6"
      },
      {
        name: "categoryId",
        type: "text",
        component: (props) =>
          <SelectObjectsField api="api/category"
            reduxState="roomCategories"
            sname="categoryId"
            label="کاربری" {...props} />,
        placeholder: "کاربری",
        label: "کاربری",
        rowIdx: 6,
        class: "col-lg-6"
      },
      // {
      //   name: "allowedAnswer",
      //   type: "text",
      //   component: Input,
      //   placeholder: "پاسخ مجاز",
      //   label: "پاسخ مجاز",
      //   rowIdx: 3,
      //   class: "col-lg-4"
      // },
    ]
  },
  // {
  //   row: 2,
  //   list: [
  //     {
  //       name: "answerType",
  //       type: "text",
  //       component: Input,
  //       placeholder: "نوع پاسخ",
  //       label: "نوع پاسخ",
  //       rowIdx: 5,
  //       class: "col-lg-4"
  //     },
  //   ]
  // },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];


export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const prepareFilter = (queryParams, values) => {
  const { isDeleted, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // Filter by all fields
  filter.title = searchText;
  if (searchText) {
    filter.title = searchText;
  }
  newQueryParams.filter = filter;

  let whereClause = "title.contains(@0)"
  const whereClauseParameters = [];
  whereClauseParameters.push(searchText)


  if (filter.isDeleted !== undefined) {
    whereClause = whereClause + " and isDeleted=@1"
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true)
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  // formTypeId: Yup.number()
  //   .required("formTypeId is required"),
  // questionId: Yup.number()
  //   .required("questionId is required"),

});

